import React, { useState } from 'react';
import { usePanelConfig } from '../../../../modules/panel';
import { PANEL_LEVEL } from '../../../../config/panelConfig/panelTypes';

/**
 * PanelTypesTab - Panel tiplerini listeler, çıkışları inline düzenle
 */
export default function PanelTypesTab() {
  const { panelTypes, outputTypes, outputCategories, updatePanelOutputs, updateAllowedChildPanels, updatePanelType } = usePanelConfig();
  const [expandedId, setExpandedId] = useState(null);

  const primaryTypes = Object.values(panelTypes).filter(
    pt => pt.level === PANEL_LEVEL.PRIMARY
  );
  const gtChildTypes = Object.values(panelTypes).filter(
    pt => pt.level === PANEL_LEVEL.GT_CHILD
  );

  const allOutputTypesList = Object.values(outputTypes).filter(
    ot => ot.categoryId !== 'PANEL'
  );

  const sortedCategories = Object.values(outputCategories)
    .filter(c => c.id !== 'PANEL')
    .sort((a, b) => a.order - b.order);

  const toggleExpand = (id) => {
    setExpandedId(prev => prev === id ? null : id);
  };

  const handleToggleOutput = (panelTypeId, outputId) => {
    const pt = panelTypes[panelTypeId];
    if (!pt) return;
    const current = pt.defaultOutputs;
    const newOutputs = current.includes(outputId)
      ? current.filter(id => id !== outputId)
      : [...current, outputId];
    updatePanelOutputs({ panelTypeId, defaultOutputs: newOutputs });
  };

  const handleToggleChildPanel = (panelTypeId, childId) => {
    const pt = panelTypes[panelTypeId];
    if (!pt) return;
    const current = pt.allowedChildPanels;
    const newChildren = current.includes(childId)
      ? current.filter(id => id !== childId)
      : [...current, childId];
    updateAllowedChildPanels({ panelTypeId, allowedChildPanels: newChildren });
  };

  const renderPanelRow = (pt) => {
    const isExpanded = expandedId === pt.id;
    const outputCount = pt.defaultOutputs.filter(id => outputTypes[id]?.categoryId !== 'PANEL').length;

    return (
      <div key={pt.id} style={{ marginBottom: 2 }}>
        <div
          className="item-row"
          style={{ cursor: 'pointer' }}
          onClick={() => toggleExpand(pt.id)}
        >
          <span className="item-row-label">
            <strong>{pt.code}</strong> - {pt.label}
            <span style={{ color: '#888', fontSize: 11, marginLeft: 6 }}>
              ({outputCount} çıkış)
            </span>
          </span>
          <span style={{ color: '#888', fontSize: 14 }}>
            {isExpanded ? '\u25B4' : '\u25BE'}
          </span>
        </div>

        {isExpanded && (
          <div style={{ background: '#2a2a2a', padding: '8px 12px', borderBottom: '1px solid #444' }}>
            {/* Çıkış Checkbox'ları - kategoriye göre gruplanmış */}
            <div style={{ fontSize: 11, color: '#7aa6ff', fontWeight: 600, marginBottom: 4 }}>
              Varsayılan Çıkışlar
            </div>
            {sortedCategories.map(cat => {
              const catOutputs = allOutputTypesList.filter(ot => ot.categoryId === cat.id);
              if (catOutputs.length === 0) return null;
              return (
                <div key={cat.id} style={{ marginBottom: 6 }}>
                  <div style={{ fontSize: 10, color: '#888', marginBottom: 2, display: 'flex', alignItems: 'center', gap: 4 }}>
                    <span style={{ width: 6, height: 6, borderRadius: '50%', background: cat.color, display: 'inline-block' }} />
                    {cat.label}
                  </div>
                  <div className="checkbox-list" style={{ maxHeight: 'none' }}>
                    {catOutputs.map(ot => (
                      <label key={ot.id}>
                        <input
                          type="checkbox"
                          checked={pt.defaultOutputs.includes(ot.id)}
                          onChange={() => handleToggleOutput(pt.id, ot.id)}
                        />
                        {ot.label}
                      </label>
                    ))}
                  </div>
                </div>
              );
            })}

            {/* Alt Panel Checkbox'ları (sadece allowedChildPanels > 0 olanlar veya PRIMARY) */}
            {pt.level === PANEL_LEVEL.PRIMARY && (
              <>
                <div style={{ fontSize: 11, color: '#7aa6ff', fontWeight: 600, marginTop: 8, marginBottom: 4 }}>
                  İzin Verilen Alt Paneller
                </div>
                <div className="checkbox-list" style={{ maxHeight: 'none' }}>
                  {Object.values(panelTypes)
                    .filter(child => child.id !== pt.id)
                    .map(child => (
                      <label key={child.id}>
                        <input
                          type="checkbox"
                          checked={pt.allowedChildPanels.includes(child.id)}
                          onChange={() => handleToggleChildPanel(pt.id, child.id)}
                        />
                        {child.label}
                      </label>
                    ))}
                </div>
              </>
            )}

            {/* SP özel: Jeneratör checkbox */}
            {pt.id === 'SP' && (
              <div style={{ marginTop: 8 }}>
                <label>
                  <input
                    type="checkbox"
                    checked={!!pt.jenerator}
                    onChange={() => updatePanelType({ id: 'SP', jenerator: !pt.jenerator })}
                  />
                  {' '}Jeneratör bağlantısı (T.P. + Jeneratör)
                </label>
              </div>
            )}
          </div>
        )}
      </div>
    );
  };

  return (
    <div>
      <div className="group-header">Birincil Panel Tipleri</div>
      <div className="item-list">
        {primaryTypes.map(renderPanelRow)}
      </div>

      <div className="group-header" style={{ marginTop: '12px' }}>GT Alt Panelleri</div>
      <div className="item-list">
        {gtChildTypes.map(renderPanelRow)}
      </div>
    </div>
  );
}
